import api from "../api";
import Swal from 'sweetalert2';
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    token: {},
    //validateToken: {},
    unable: {}
  },
  getters: {
    tokenValidate: () => localStorage.getItem("is_activated") ? true : false
  },
  actions: {

    async create_token({ commit }, email) {
      try {
          api.post("/token", {email: email})
          .then((res) => {
            commit("GET_TOKEN", res.data);
          })
          .catch((error) => {
            commit("ERROR_TOKEN", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_TOKEN", e);
      }
    },   

    async validate_token({ dispatch, commit }, payload) {
      try {
          api.post("/validate-token", payload)
          .then((res) => {
            //commit("GET_OK_TOKEN", res.data);
            if(res.data.erro){

              //if (window.innerWidth < 480) {
                toast.warning(res?.data?.message, {
                  type: 'default',
                  theme: 'colored',
                  hideProgressBar: true,
                  dangerouslyHTMLString: true
                });
              //}

              //dispatch("alert/set_alert", {alert_message: res?.data?.message, type_message: 'alert-warning'}, { root: true });
            }
            else {
              localStorage.setItem("is_activated", true)
              let timerInterval;
              Swal.fire({
                title: "Solicitação aberta",
                html: "Será redirecionado para home em: <i class=\"far fa-clock\"></i> <b></b>",
                timer: 5000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading();
                    const timer = Swal.getPopup().querySelector("b");
                    timerInterval = setInterval(() => {
                      timer.textContent = `${parseInt(Swal.getTimerLeft() / 1000)}`;
                    }, 1000);
                    
                },
                willClose: () => {
                  clearInterval(timerInterval);
                }
              }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === Swal.DismissReason.timer) {
                  location.reload();
                }
              });
            }
          })
          .catch((error) => {
            commit("ERROR_OK_TOKEN", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_OK_TOKEN", e);
      }
    },  

    async unable_token({ commit }) {
      try{
          api.post("/unable")
          .then((res) => {
            commit("GET_UNABLE", res.data);
          })
          .catch((error) => {
            commit("ERROR_UNABLE", error);
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        commit("ERROR_UNABLE", e);
      }
    }, 
    
  },
  mutations: {
    GET_TOKEN(state, data) {
      state.token = data
    },
    ERROR_TOKEN(state, data) {
      console.log(data)
    },

    GET_OK_TOKEN(state, data) {
      if(data.erro){
        console.log(data, 'dentro do if')
      }
      else {
        console.log(data, 'dentro do else')
      }
      //state.validateToken = data
      //console.log(data)
    },
    ERROR_OK_TOKEN(state, data) {
      console.log(data)
    },

    GET_UNABLE(state, data) {
      state.unable = data
    },
    ERROR_UNABLE(state, data) {
      console.log(data)
    },
  }
}